<template>
  <div
    class="manager-page"
    :class="{
      'close-side-menu': this.$store.state.isOpen,
      'mini-side-menu': this.$store.state.isMini,
      'sm-side-menu-open': this.$store.state.isSmOpen,
    }"
  >
    <SideBar />
    <div class="manager-page-content-wrap">
      <NavBar />
      <div id="manager-page-content" class="manager-page-content">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/back/Layout/NavBar";
import SideBar from "@/components/back/Layout/SideBar";
import Footer from "@/components/Layout/Footer";
import { mapGetters } from "vuex";

export default {
  name: "ManagerLayout",

  components: {
    NavBar,
    SideBar,
    Footer,
  },

  computed: {
    ...mapGetters(["isScroll"]),
  },

  watch: {
    isScroll: async function (newVal) {
      if (newVal) {
        document.getElementById("manager-page-content").scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style lang="scss">
.manager-page {
  display: flex;
  .manager-page-content-wrap {
    flex: 1;
    height: 100vh;
    overflow-y: hidden;
    padding-bottom: 80px;
    .manager-page-content {
      overflow: auto;
      height: 100%;
    }
  }

  @media screen and (min-width: 768px) {
    ///整個關閉時
    &.close-side-menu {
      .side-menu {
        width: 0 !important;
        overflow-x: hidden;
      }
    }
    ///縮小只呈現icon時
    &.mini-side-menu {
      .side-menu {
        width: unset;

        .site-name {
          padding: 20px 0;
          img {
            width: 55px;
            padding: 0 10px;
            margin-right: 0;
          }
          span {
            display: none;
          }
        }
        .side-menu-inner {
          overflow-y: unset;
          .has-sub-menu {
            position: relative;
            &::after {
              display: none;
            }

            &:hover {
              ul {
                display: block;
                z-index: 70;
                li {
                  a {
                    padding: 10px 30px;
                  }
                }
              }
            }

            .has-sub-menu-inner {
              .icon-wrap {
                margin-right: 0;
              }
              span {
                display: none;
              }
            }

            ul {
              position: absolute;
              max-height: unset;
              right: 0;
              transform: translateX(100%);
              top: 0;
              background-color: #373737;
              display: none;
            }
          }
        }
      }

      .sidebar-minimizer-btn {
        i {
          transform: rotate(180deg);
        }
      }
    }
  }

  @media screen and (max-width: 767px) {
    &.sm-side-menu-open {
      .side-menu {
        width: 100%;
        transform: translateX(0);
      }
    }
  }
}
</style>
